import { h, Component } from 'preact';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';

import configureStore from './redux/store';

import Shell from 'q-components/components/shell';
import { shellConfig, desktopShellConfig } from './shellConfig.js';

import VAP from './containers/VAP';
import SNB from './containers/SNB';
import Homepage from './containers/Homepage';
import RTO from './containers/RTO';
import Inspection from './containers/Inspection';
import BikePoint from './containers/BikePoint';
import BikeCarYard from './containers/BikeCarYard';
import Leads from './containers/Partnership';
import Success from './containers/PaymentSuccess';

// Grab the state from a global variable injected into the server-generated HTML
let preloadedState;
// Allow the passed state to be garbage-collected
if (typeof window !== 'undefined') {
    preloadedState = window.__PRELOADED_STATE__;
    // delete window.__PRELOADED_STATE__;
}

const store = configureStore(preloadedState);

const reload404=() => location.href=location.href;
class App extends Component {

    render (props) {
        return (
            <Provider store={store}>
                <Shell config={(preloadedState && preloadedState.isMobile) ? shellConfig : desktopShellConfig}>
                    <Switch>
                        <Route component={BikePoint} path="/(cars|bikes-scooters)/(car-yards|bike-points)-in-:slug([a-zA-Z0-9\-]+)" />
                        <Route component={BikeCarYard} path="/:type(cars|bikes-scooters)/(used-car-showroom|used-bike-showroom)-:name([a-zA-Z]+)-:city([a-zA-Z]+)-:id([0-9]+)" />
                        <Route component={Leads} path="/cars-bikes/partnerships/:slug([a-zA-Z0-9\-]+)" />
                        <Route component={Success} path="/cars-bikes/warranty/payment-success" />
                        <Route component={Inspection} path="/cars-bikes/inspection/:id([0-9a-zA-Z]+)" />
                        <Route component={VAP} path="/:type(cars|cars-bikes|bikes-scooters)/:title([0-9a-zA-z+\-\.\,]+)\+:city([a-zA-Z0-9]+)\+W0QQAdIdZ:adId([0-9]+)" />
                        <Route component={SNB} path="/:type(cars|cars-bikes|bikes-scooters)/:slug(.*[w|x|y|z][\d].*)" />
                        <Route path="/cars/:type(new-cars)/:city([a-zA-Z0-9\-]+)" render={({ match }) => (
                            <Redirect to={`/cars/used-cars/${match.params.city}`} />
                        )} />
                        <Route component={Homepage} path="/:subCat(cars)/:type(used-cars)/:city([a-zA-Z0-9\-]+)" />
                        <Route component={Homepage} path="/:subCat(bikes-scooters)/:city([a-zA-Z0-9\-]+)" />
                        <Route component={Homepage} path="/:subCat(commercial-vehicles)/:city([a-zA-Z0-9\-]+)" />
                        <Route component={RTO} path="/cars-bikes/rto-services/:slug([a-zA-Z0-9\-]+)" />
                        <Route>
                            <reload404 />
                        </Route>
                    </Switch>
                </Shell>
            </Provider>
        );
    }
}
export default  App;



// WEBPACK FOOTER //
// ../q-cars/src/appdev.js